import React from "react";
import { Link } from "gatsby";
import { twMerge } from "tailwind-merge";

interface NavLinkProps {
  children: string | React.ReactNode;
  internalPath?: string;
  externalUrl?: string;
  new_window: "_blank" | "self" | string;
  variant: "primary" | "secondary";
  className?: string;
}

const NavLink = ({ className, ...props }: NavLinkProps) => {
  // Determine the styles based on the variant prop.
  const getStyles = () => {
    switch (props.variant) {
      case "secondary":
        return "font-body font-bold text-[22px] underline tracking-[0.44px] text-white hover:text-salmon transition md:text-lg md:tracking-[0.36px] md:font-semibold";
      default:
        return "font-heading text-4xl tracking-[2.88px] text-white hover:text-salmon transition md:text-2xl md:tracking-[1.92px]";
    }
  };

  const styles = getStyles();

  // Common properties shared by both Link and anchor (<a>) elements.
  const commonProps = {
    target: props.new_window,
    className: twMerge(styles, className),
  };

  // Ensure that internal path is not blank. If not, render link as Gatsby Link.
  if (props.internalPath) {
    return (
      <Link to={props.internalPath} {...commonProps}>
        {props.children}
      </Link>
    );
    // Render as a default anchor tag.
  } else {
    return (
      <a href={props.externalUrl} {...commonProps}>
        {props.children}
      </a>
    );
  }
};

export default NavLink;

// Types for data from Kontent.ai
export type KontentNavigationLink = {
  system: { type: string };
  elements: {
    external_url: { value: string };
    internal_path: { value: string };
    text: { value: string };
    new_window: { value: [{ codename: string }] };
  };
};
